import { MutationResult } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';
import { Injectable, inject } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { MARKNOTIFICATION_AS_READ, USER_NOTIFICATIONS } from '@riise/graphql/notifications/notifications.queries';
import { GET_NEW_REQUEST_NOTIFICATION } from '@riise/graphql/notifications/notifications.subscription';
import { UPDATE_NOTIFICATIONS } from '@riise/graphql/notifications/notifications.mutations';
import { MatDialog } from '@angular/material/dialog';
import { AnnouncementComponent } from "@riise/shared/components/announcement/announcement.component";

@Injectable({
    providedIn: 'root',
})

export class NotificationsService {

    private apollo = inject(Apollo);
    private dialog = inject(MatDialog);


    markNotificationAsRead(
      user: any
    ) {
        return this.apollo.mutate<any>({
            mutation: MARKNOTIFICATION_AS_READ,
            variables: {
              user: user,
            },
        });
    }

    getUserNotifications(variables?: any) {
        return this.apollo.watchQuery<any>({
            query: USER_NOTIFICATIONS,
            fetchPolicy: 'no-cache',
            variables
        }).valueChanges;
    }

    showAnnouncementPopup(reference: any) {
        const dialogRef = this.dialog.open(AnnouncementComponent, {
            data: reference,
            hasBackdrop: false,
            panelClass: 'no-backdrop-dialog'
        });
    }

    getNewRequestNotification(receiver: string): Observable<any> {
        return this.apollo.subscribe({
            query: GET_NEW_REQUEST_NOTIFICATION,
            fetchPolicy: 'no-cache',
            variables: { receiver }
        });
    }

    updateNotifications(id: number, isActive: boolean) {
        return this.apollo.mutate<any>({
            mutation: UPDATE_NOTIFICATIONS,
            variables: { id, isActive }
        });
    }
}

